<template>
  <div class="page-top editor-pick">
    <div class="page-top-inner-wrap">
      <template v-for="(title, index) in titleList">
        <template v-if="index === 0">
          <h1
            :key="'editorpick_' + index"
            tabindex="0"
            class="page-title"
            v-html="getTitleText(title.text)"
          ></h1>
        </template>
        <template v-else>
          <p
            :key="'editorpick_' + index"
            class="page-text"
            v-html="getTitleText(title.text)"
          ></p>
        </template>
      </template>
      <div class="btn-wrap">
        <btn-zzim-with-api
          v-if="!isPooqzone"
          :is-on="isZzim"
          contents-type="theme"
          :contents-id="themeId"
          :is-mypooq="false"
        />
      </div>
    </div>
  </div>

  <!--  <div class="editorpick-title">-->
  <!--    <div class="wrap">-->
  <!--      <btn-zzim-with-api v-if="!isPooqzone" :isOn="isZzim" contentsType="theme" :contentsId="themeId" :is-mypooq="false"/>-->
  <!--      <div class="title"></div>-->
  <!--      <span v-for="(title, index) in titleList" :key="index" v-html="title.text"></span>-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>
  import _ from 'lodash'
  import cookie from '@/common/utils/cookie'
  import BtnZzimWithApi from '@/components/button/BtnZzimWithApi'
  export default {
    name: 'EditorPickHeader',
    components: { BtnZzimWithApi },
    props: {
      titleList: {
        type: Array,
      },
      topButtonList: {
        type: Array,
      },
    },
    data() {
      return {
        isZzim: 'n',
        themeId: '',
        isPooqzone: cookie.isWavveOn(),
      }
    },
    created() {
      const zzimButton = this.topButtonList.filter((button) => {
        return _.get(button, 'buttontype', '') === 'zzim'
      })[0]
      const eventList = _.get(zzimButton, ['event_list'], [])
      this.hasHeart = eventList.length > 0
      if (this.hasHeart) {
        this.isZzim = _.get(zzimButton, 'buttonstate', 'n')
        const onRadioEvent = eventList.filter((event) => {
          return event.type === 'on-radio'
        })[0]
        const url = _.get(onRadioEvent, 'url', '')
        const themeId = url.split('/').pop()
        this.themeId = isNaN(themeId)
          ? _.get(onRadioEvent, ['bodyjson', 'contentids', '0'], '')
          : themeId
      }
    },
    methods: {
      getTitleText(title) {
        return title.replace('<', '&lt;').replace('>', '&gt;')
      },
    },
  }
</script>
